import React, { useMemo } from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { titv_network_index_path } from '@routes';
import { TrackingLocation } from '@tracking';
import type { TITVEvent } from '@utils/backend-api/titv';

import TITVMultistreamFeatureHeroStreamCard from './HeroStreamCard';
import ViewAllLink from './ViewAllLink';
import { VIEW_ALL_TEXT } from './constants';

interface TITVMultistreamFeatureHeroStreamsProps {
  mostRecentStreamId?: number;
  network: string;
  networkId: number;
  streams: TITVEvent[];
  title: string;
}

const TITVMultistreamFeatureHeroStreams = ({
  mostRecentStreamId,
  network,
  networkId,
  title,
  streams,
}: TITVMultistreamFeatureHeroStreamsProps) => {
  const { Track } = useEventTracking({
    location: TrackingLocation.ExploreEpisodes,
  });

  const filteredStreams = useMemo(() => {
    const filteredStreams = streams.filter((stream) => stream.id !== mostRecentStreamId);
    return filteredStreams.slice(0, 4);
  }, [streams, mostRecentStreamId]);

  return (
    <Track>
      <article className="mt-32 w-full border-0 border-t border-solid border-grayscale-charcoal pt-20 sm:border-grayscale-beige sm:pt-40 lg:mt-40">
        <header className="flex w-full flex-row justify-between">
          <h2 className="m-0 shrink-0 text-balance font-suisse-intl-mono text-overline-sm font-normal text-primary-black sm:text-overline-lg">
            Explore {title} episodes
          </h2>
          <ViewAllLink
            className="m-0 !w-auto text-right font-suisse-intl-mono text-overline-sm font-normal text-primary-magenta sm:text-overline-lg"
            link={titv_network_index_path(network)}
            networkId={networkId}
            text={VIEW_ALL_TEXT}
          />
        </header>
        <section className="-mx-16 mt-32 flex flex-row flex-nowrap gap-32 overflow-x-auto px-16 sm:-mx-28 sm:px-28 nav:mx-0 nav:flex-nowrap nav:overflow-x-hidden nav:px-0">
          {filteredStreams.map((stream) => (
            <TITVMultistreamFeatureHeroStreamCard
              key={stream.id}
              className="min-w-[65svw] !border-0 !px-0 !pb-0 sm:min-w-[calc(50svw-72px)] nav:min-w-0"
              stream={stream}
              isFluid
            />
          ))}
        </section>
      </article>
    </Track>
  );
};

export default TITVMultistreamFeatureHeroStreams;
